import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";

type StyledMapProps = {
  children?: JSX.Element;
  centroid?: { lat: number; lng: number };
  zoomed?: number;
  handleMapClick?: (e: any) => void;
  data?: any;
  mapContainerHeight?: string;
};

const StyledMap = (props: StyledMapProps) => {
  const {
    children,
    handleMapClick,
    zoomed = 12,
    centroid,
    data,
  } = props;
  const [renderMap, setRenderMap] = useState(false);
  const [currentLocation, setCurrentLocation] = useState({
    lat: 24.7136, 
    lng: 46.6753, 
  });

  const mapContainerStyle = {
    width: "100%",
    height: "80%",
  };

  // Get user's current location
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          console.log(position,"positionpositionposition")
          setCurrentLocation({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        (error) => {
          console.warn("Error getting location:", error);
          // Keep default location (Riyadh) if geolocation fails
        },
        {
          enableHighAccuracy: true,
          timeout: 10,
          maximumAge: 60000,
        }
      );
    }
  }, []);

  useEffect(() => {
    setRenderMap(false);
    const timeout = setTimeout(() => {
      setRenderMap(true);
    }, 2500);
    return () => clearTimeout(timeout);
  }, [data]);

  // Use centroid prop if provided, otherwise use current location
  const mapCenter = centroid || currentLocation;

  return (
    <>
      {renderMap && (
        <MapContainer
          center={[mapCenter.lat, mapCenter.lng]}
          zoom={zoomed}
          style={{ ...mapContainerStyle, zIndex: 0 }}
          //@ts-ignore
          eventHandlers={{
            click: handleMapClick,
          }}
          attributionControl={false} // Disable Leaflet attribution control
        >
          <TileLayer
            attribution={''}
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {children}
        </MapContainer>
      )}
    </>
  );
};

export default StyledMap;
